'use strict';

class Contact {

	constructor() {
		jQuery(() => {
			this.$ = jQuery;
			this.initModal();
		});
	}

	initModal() {
		this.$(document)
			.on('click', '#me-contact-confirm-button', (e) => {
				if (!this.validate()) {
					return;
				}
				this.openModal();
			})
			.on('click', '#me-contact-cancel-button', (e) => {
				this.closeModal();
			})
			.on('wpcf7submit', (e) => {
				this.closeModal();
			});
	}

	openModal() {
		const form = this.$('form');
		this.$('#me-confirm-company-name').text(form.find('[name="company-name"]').val());
		this.$('#me-confirm-revision').text(form.find('[name="revision"]').val());
		this.$('#me-confirm-pic-name').text(form.find('[name="pic-name"]').val());
		this.$('#me-confirm-pic-name-furigana').text(form.find('[name="pic-name-furigana"]').val());
		this.$('#me-confirm-email').text(form.find('[name="email"]').val());
		this.$('#me-confirm-content').html(form.find('[name="content"]').val().replace(/\r?\n/g, '<br>'));
		this.$('.me-global-navi').css({ zIndex: 0 });
		this.$('.me-confirm-modal').addClass('active');
	}

	closeModal() {
		this.$('.me-global-navi').css({ zIndex: 1 });
		this.$('.me-confirm-modal').removeClass('active');
	}

	validate() {
		let isInvalid = false;
		const self = this;

		// 必須項目チェック
		self.$('.me-required').each(function () {
			const val = self.$(this).find('> span:last-of-type').find('input, textarea').val();
			if (val) {
				self.$(this).removeClass('me-invalid');
			} else {
				self.$(this).addClass('me-invalid');
				isInvalid = true;
			}
		});

		// Emailチェック
		const email = self.$('input[name="email"]').val();
		const emailConfirm = self.$('input[name="email-confirm"]').val();
		if (email && emailConfirm && email === emailConfirm) {
			self.$('input[type="email"]').closest('.me-form-group').removeClass('me-invalid');
		} else {
			self.$('input[type="email"]').closest('.me-form-group').addClass('me-invalid');
			isInvalid = true;
		}

		// 同意チェック
		if (self.$('input[name="acceptance"]').prop('checked')) {
			self.$('.me-form-agreement').removeClass('me-invalid');
		} else {
			self.$('.me-form-agreement').addClass('me-invalid');
			isInvalid = true;
		}

		return !isInvalid;
	}
}

new Contact();



// WEBPACK FOOTER //
// ./assets/src/scripts/contact.js